<template>
    <v-card>
        <v-form
            ref="importgrvsform"
            v-model="isValid"
        >
            <v-card-text>
                <v-card-title>Import Payment Updates</v-card-title>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-file-input
                                :disabled="isLoading"
                                accept=".csv"
                                label="Grv payments csv file"
                                placeholder="Select csv file"
                                ref="file"
                                v-model="file"
                            ></v-file-input>
                        </v-col>
                    </v-row>

                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="importGrvs"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Import</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
//import dateToString from "../../helpers/dateToString"
export default {
    components: {
        //
    },
    data() {
        return {
            isValid: null,
            isLoading: null,
            isSaving: null,

            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,

            file: null
        };
    },
    created: async function() {},
    methods: {
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.cleanup();
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.importgrvsform.validate();
            return this.isValid;
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
        //save      ------------------------------------------------------------
        async importGrvs() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var formdata = new FormData();
                formdata.append("File", this.file);

                try {
                    var resultFileId = await this.$store.dispatch(
                        "accounts/grvimport",
                        formdata
                    );
                    this.getFile(resultFileId, "GrvImportResult");
                    this.notify("Done", "success");
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.cleanup();
            }
        },
        cleanup()
        {
            this.isLoading = false;
            this.isSaving = false;
            this.file = null;
        }
    }
};
</script>

<style lang="stylus" scoped></style>